import { useQuery } from '@tanstack/react-query'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the membership plans we currently sell plus the addon catalogue, for the active region. */
export function useListPlans() {
  const api = useOsApi()
  const { region } = useViewerRegion()

  return useQuery({
    queryKey: ['plans', { region }],
    queryFn: async () => {
      const response = await api.get('/plans', { query: { region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    staleTime: 5 * 60_000, // Plans rarely change — cache for 5 minutes
  })
}
